import { makeFetchAction } from './utils';
import { getBillingOnNewPlatform } from '../Services/SupabaseService';

export const fetchBillingOnNewPlatform = makeFetchAction({
  actionGroup: 'NEW_PLATFORM',
  actionName: 'FETCH_BILLING',
  fetchData: getBillingOnNewPlatform,
  onSucceedPayload: (args, data) => data,
  onErrorPayload: (args, error) => error && error.message,
});
